import React, { useState } from 'react';

import { LANGUAGE_NAMES } from '../../constants';
import { Body, Container, Header, Language, LanguageList } from './styles';

type PropTypes = {
  children: Array<React.ReactElement>;
};

const MultiLanguage = ({ children }: PropTypes): JSX.Element => {
  const [currentLanguage, setCurrentLanguage] = useState(0);
  const currentComponent = children[currentLanguage];

  return (
    <Container>
      <Header>
        <LanguageList>
          {children.map(({ props }, index) => {
            const langKey = props['data-language'];
            const label = LANGUAGE_NAMES[langKey];
            const active = index === currentLanguage;

            return (
              <Language
                active={active}
                key={langKey}
                type="button"
                data-testid={`change-language-${index}`}
                onClick={(): void => setCurrentLanguage(index)}
              >
                {label}
              </Language>
            );
          })}
        </LanguageList>
      </Header>
      <Body>{currentComponent}</Body>
    </Container>
  );
};

export default MultiLanguage;
